import { useEffect, useState } from "react";

// ASSETS
import { ReactComponent as GreyPhoneIcon } from "assets/svg/GreyPhoneIcon.svg";
import { ReactComponent as LocationPinIcon } from "assets/svg/LocationPinIcon.svg";
import DsuIcon from "assets/svg/LogoDsu.svg";
import PlaceholderImage from "assets/svg/PlaceholderImage.svg";
import { ReactComponent as ScheduleIcon } from "assets/svg/ScheduleIcon.svg";
import { ReactComponent as WebsiteIcon } from "assets/svg/WebsiteIcon.svg";

// STYLES
import {
  AbsolutContainer,
  ButtonWrapper,
  DefibBody,
  DefibContainer,
  DefibPhoto,
  DefibPhotoContainer,
  DefibPhotoURL,
  DetailsWrapper,
  DsuImg,
  DsuWrapper,
  IconWrapper,
  Informations,
  InformationsContainer,
  InformationsFormat,
  InfoTittleContainer,
  ModalActions,
  ModalBody,
  PinInfoContainer,
  PopupModal,
  RedLine,
  Schedule,
} from "components/Atoms/ResponsiveModal/ResponsiveModalStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { COLORS } from "constants/variables";
import { uploadBaseUrl } from "services/base";
import { ButtonType } from "../ButtonAtom/ButtonAtomModel";
import { TextType } from "../CustomText/CustomTextModel";
import { ModalType, ResponsiveModalProps } from "./ResponsiveModalModel";

// REDUX

// COMPONENTS
import { appRoutes } from "config/AppRoutesConfig";
import { useNavigate } from "react-router-dom";
import { secondUploadBaseUrl } from "services/helperBase";
import ButtonAtom from "../ButtonAtom/ButtonAtom";
import CustomText from "../CustomText/CustomText";
import PillAtom from "../PillAtom/PillAtom";

const ResponsiveModal = (props: ResponsiveModalProps) => {
  // PROPERTIES
  const {
    type = ModalType.Info,
    id,
    onClose,
    isOpen = false,
    selectedIpCategory,
    title,
    canCallEmergency,
    stats,
    photo,
    phone,
    adress,
    website,
    children,
    schedule,
    long,
    lat,
    date,
    partener,
  } = props;

  // LIBRARY CONSTANTS
  const { t } = useTranslation();

  // STATE CONSTANTS
  const [isOpened, setIsOpened] = useState(false);
  // const scheduleArray = schedule ? schedule.split(",") : [];
  const navigate = useNavigate();
  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    setIsOpened(isOpen);
  }, [isOpen]);
  const handleClose = () => {
    onClose();
  };

  // EVENT HANDLERS
  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("popup-container")) {
      handleClose();
    }
  };
  // Function to handle closing the popup

  const handleClick = () => {
    navigate(`${appRoutes.eventDetails}${id}`);
    handleClose();
  };

  return (
    <PopupModal
      className="popup-container"
      onClick={handleOutsideClick}
      open={isOpened}
      selectedIpCategory={selectedIpCategory}
    >
      <ModalBody open={isOpen}>
        <AbsolutContainer type={type}>
          {type === ModalType.Info && (
            <CustomText text={t("map.modal.pointOfInterest")} type={TextType.H4} />
          )}
          <ButtonAtom onClick={handleClose} type={ButtonType.X} />
        </AbsolutContainer>
        {type === ModalType.Defib && (
          <DefibContainer>
            <DefibPhotoContainer>
              {photo ? (
                <DefibPhotoURL src={`${secondUploadBaseUrl}${photo}`} />
              ) : (
                <DefibPhoto src={PlaceholderImage} />
              )}
            </DefibPhotoContainer>
            <DefibBody>
              <CustomText text={title} type={TextType.H3} />
              <RedLine />
              <DetailsWrapper>
                {canCallEmergency && <PillAtom
                    text={t("components.responsiveModal.call")}
                    status={canCallEmergency}
                />}
                <PillAtom
                    text={stats ? "Deschis" : "Închis"}
                    status={stats}
                />
              </DetailsWrapper>
              <InformationsContainer>
                <Schedule>
                  <IconWrapper>
                    <ScheduleIcon />
                  </IconWrapper>
                  <InformationsFormat>
                    {children ? (
                      children
                    ) : (
                      <CustomText
                        text={t("components.responsiveModal.noSchedule")}
                        type={TextType.P1}
                      />
                    )}
                  </InformationsFormat>
                </Schedule>
                <Schedule>
                  <IconWrapper>
                    <GreyPhoneIcon />
                  </IconWrapper>
                  <Informations>
                    <CustomText
                      text={phone || t("components.responsiveModal.noNumber")}
                      type={TextType.P1}
                    />
                  </Informations>
                </Schedule>
                <Schedule>
                  <IconWrapper>
                    <LocationPinIcon />
                  </IconWrapper>
                  <Informations>
                    <CustomText
                      text={adress || t("components.responsiveModal.noAdress")}
                      type={TextType.P1}
                    />
                  </Informations>
                </Schedule>
              </InformationsContainer>
              <ModalActions>
                <ButtonAtom
                  text={t("map.modal.navigate")}
                  type={ButtonType.RedButton}
                  onClick={() => {
                    const url = `https://www.google.com/maps/dir/Current+Location/${lat},${long}`;
                    window.open(url, "_blank");
                  }}
                />
              </ModalActions>
            </DefibBody>
          </DefibContainer>
        )}
        {type === ModalType.Event && (
          <DefibContainer>
            <DefibPhotoContainer>
              {photo ? (
                <DefibPhotoURL src={`${uploadBaseUrl}${photo}`} />
              ) : (
                <DefibPhoto src={PlaceholderImage} />
              )}
            </DefibPhotoContainer>
            <DefibBody>
              <CustomText text={title} type={TextType.H3} />
              <RedLine />
              <DsuWrapper>
                <DsuImg src={DsuIcon} />
                <CustomText
                  type={TextType.H4}
                  text={partener}
                  color={COLORS.MetalicSilver}
                />
              </DsuWrapper>

              <InformationsContainer>
                <Schedule>
                  <IconWrapper>
                    <ScheduleIcon />
                  </IconWrapper>
                  <InformationsFormat>
                    <CustomText
                      text={date || t("components.responsiveModal.noSchedule")}
                      type={TextType.P1}
                    />
                  </InformationsFormat>
                </Schedule>

                <Schedule>
                  <IconWrapper>
                    <LocationPinIcon />
                  </IconWrapper>
                  <Informations>
                    <CustomText
                      text={adress || t("components.responsiveModal.noAdress")}
                      type={TextType.P1}
                    />
                  </Informations>
                </Schedule>
              </InformationsContainer>
              <ModalActions>
                <ButtonWrapper>
                  <ButtonAtom
                    type={ButtonType.RedButton}
                    text={t(
                      "view.newsAndMedia.officialAnnouncements.openButton"
                    )}
                    hasArrow={true}
                    onClick={handleClick}
                  />
                </ButtonWrapper>
              </ModalActions>
            </DefibBody>
          </DefibContainer>
        )}
        {type === ModalType.Info && (
          <PinInfoContainer>
            <InfoTittleContainer>
              <CustomText text={title} type={TextType.H3} />
            </InfoTittleContainer>
            <RedLine />
            <InformationsContainer>
              <Schedule>
                <IconWrapper>
                  <GreyPhoneIcon />
                </IconWrapper>
                <Informations>
                  <CustomText
                    text={phone || t("components.responsiveModal.noNumber")}
                    type={TextType.H4}
                  />
                </Informations>
              </Schedule>
              <Schedule>
                <IconWrapper>
                  <WebsiteIcon />
                </IconWrapper>
                <Informations>
                  <CustomText
                    text={website || t("components.responsiveModal.noWebsite")}
                    type={TextType.H4}
                  />
                </Informations>
              </Schedule>
              <Schedule>
                <IconWrapper>
                  <LocationPinIcon />
                </IconWrapper>
                <Informations>
                  <CustomText
                    text={adress || t("components.responsiveModal.noAdress")}
                    type={TextType.H4}
                  />
                </Informations>
              </Schedule>
            </InformationsContainer>
            <ModalActions>
              <ButtonAtom
                text={t("map.modal.navigate")}
                type={ButtonType.RedButton}
                onClick={() => {
                  const url = `https://www.google.com/maps/dir/Current+Location/${lat},${long}`;
                  window.open(url, "_blank");
                }}
              />
            </ModalActions>
          </PinInfoContainer>
        )}
      </ModalBody>
    </PopupModal>
  );
};
export default ResponsiveModal;
